import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import DialogContent from "@material-ui/core/DialogContent";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// services
import levelService from "services/level.service";
// management imports
import CadastrarLivros from "./Cadastrar";
import EditarLivros from "./Editar";
import DeletarLivros from "./Deletar";

const styles = (theme) => ({
	cardCategoryWhite: {
		"&,& a,& a:hover,& a:focus": {
			color: "rgba(255,255,255,.62)",
			margin: "0",
			fontSize: "14px",
			marginTop: "0",
			marginBottom: "0",
		},
		"& a,& a:hover,& a:focus": {
			color: "#FFFFFF",
		},
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
		"& small": {
			color: "#777",
			fontSize: "65%",
			fontWeight: "400",
			lineHeight: "1",
		},
	},
});

class GerenciarNiveis extends Component {
	constructor(props) {
		super(props);
		this.state = { levels: [], show: "", editUid: "" };
		this.handleSearch();

		// this.handleChange = this.handleChange.bind(this);
		// this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleOpenCreate = () => {
		this.setState({ show: "create" });
	};

	handleOpenEdit = (uid) => {
		this.setState({ show: "edit", editUid: uid });
	};

	handleOpenDelete = (uid) => {
		this.setState({ show: "delete", editUid: uid });
	};

	handleSearch() {
		levelService.listAllLevels().then((levels) => {
			const tableLevels = [];
			levels.forEach((level) => {
				tableLevels.push([
					level.key,
					level.order,
					level.title,
					level.language === "english"
						? "Inglês"
						: level.language === "spanish"
						? "Espanhol"
						: level.language,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenEdit(level.key);
						}}
					>
						Editar
					</Button>,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenDelete(level.key);
						}}
					>
						Excluir
					</Button>,
				]);
			});
			this.setState({ levels: tableLevels });
		});
	}

	render() {
		const { classes } = this.props;
		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Button
						color="primary"
						type="submit"
						round
						onClick={this.handleOpenCreate}
						children="Cadastrar Livro"
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary">
							<h4 className={classes.cardTitleWhite}>
								Lista de Livros
							</h4>
							<p className={classes.cardCategoryWhite}>
								Lista para visualização e gerenciamento dos
								Livros
							</p>
							<p>
								Obs: Livros são ordenados da menor para a maior
								ordem
							</p>
						</CardHeader>
						<CardBody>
							<Table
								tableHeaderColor="primary"
								tableHead={[
									"ID do Livro",
									"Ordem do Livro",
									"Título do Livro",
									"Língua",
									"Editar",
									"Excluir",
								]}
								tableData={this.state.levels}
							/>
						</CardBody>
					</Card>
				</GridItem>
				<Modal
					open={this.state.show === "create"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<CadastrarLivros
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
				<Modal
					open={this.state.show === "edit"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<EditarLivros
							uid={this.state.editUid}
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
				<Modal
					open={this.state.show === "delete"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<DeletarLivros
							uid={this.state.editUid}
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
			</GridContainer>
		);
	}
}

GerenciarNiveis.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GerenciarNiveis);
